import { PipeTransform } from '@angular/core';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { TranslateService } from '@ngx-translate/core';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';
var WarrantyStatusPipe = /** @class */ (function () {
    function WarrantyStatusPipe(translateService, fuseTranslationLoaderService) {
        this.translateService = translateService;
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
    }
    WarrantyStatusPipe.prototype.transform = function (status) {
        switch (status) {
            case 'active':
                return this.translateService.instant('WARRANTY_STATUS.ACTIVE');
            case 'expired':
                return this.translateService.instant('WARRANTY_STATUS.EXPIRED');
            case 'extended':
                return this.translateService.instant('WARRANTY_STATUS.EXTENDED');
            case 'future':
                return this.translateService.instant('WARRANTY_STATUS.FUTURE');
            default:
                return null;
        }
    };
    return WarrantyStatusPipe;
}());
export { WarrantyStatusPipe };
